module.exports = __webpack_public_path__ + "front/img/p1.69e79da8.png";